import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const BookFormat = pgTable(
  'book_format',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    order: integer().notNull(),
    legacyFormatId: integer(),
    legacyNeonBookFormatId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    uniqueIndex('book_format_name_idx').on(columns.name),
    index('book_format_order_idx').on(columns.order),
    index('book_format_updated_at_idx').on(columns.updatedAt),
    index('book_format_created_at_idx').on(columns.createdAt),
    index('book_format_legacy_neon_book_format_id_idx').on(columns.legacyNeonBookFormatId),
  ],
)

export const InsertBookFormatSchema = createInsertSchema(BookFormat)
export const UpdateBookFormatSchema = createUpdateSchema(BookFormat)
  .omit({ id: true, legacyFormatId: true, legacyNeonBookFormatId: true })
  .partial()
export const SelectBookFormatSchema = createSelectSchema(BookFormat)

export type InsertBookFormat = typeof BookFormat.$inferInsert
export type UpdateBookFormat = z.infer<typeof UpdateBookFormatSchema>
export type SelectBookFormat = typeof BookFormat.$inferSelect
